import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-forms',
  templateUrl: './ui-forms.component.html'
})
export class UiFormsComponent implements OnInit {

  select: any[] = [
    {
      name: 'Тестирование 1',
      id: '1'
    },
    {
      name: 'Тестирование 2',
      id: '2'
    },
    {
      name: 'Тестирование 3',
      id: '3'
    },
    {
      name: 'Тестирование 4',
      id: '4'
    },
    {
      name: 'Тестирование 5',
      id: '5'
    },
    {
      name: 'Тестирование 6',
      id: '6'
    },
    {
      name: 'Тестирование 7',
      id: '7'
    },
    {
      name: 'Тестирование 8',
      id: '8'
    },
    {
      name: 'Тестирование 9',
      id: '9'
    }
  ];
  selected: any[] = [];
  selectedOuter: any[] = [];
  singleSelected: any;

  constructor() { }

  ngOnInit() {
  }

}
